// import dayjs from 'dayjs';
// import { useState } from 'react';
// import { CLIENT_GSERVICE_URL } from 'src/constants';
import _ from 'lodash';

const WidgetOilStat = ({ iframeoil }) => {
  // const [dataOil, setDataOil] = useState(null);

  // useEffect(async () => {
  //   const res = await fetch(`${CLIENT_GSERVICE_URL}/oil`);
  //   const resJson = await res.json();
  //   setDataOil(resJson);
  // }, []);

  // let dataUpdate = null;
  // if (dataOil !== null) {
  //   dataUpdate = dayjs(dataOil?.datetime).locale('th').format('DD MMM BBBB เวลา H:mm น.');
  // }

  return (
    <div className='widget-oil-stat'>
      {!_.isEmpty(iframeoil?.[0]?.value) && (
        <div
          dangerouslySetInnerHTML={{
            __html: `
              ${iframeoil?.[0]?.value || <iframe width='400' height='650' src='https://www.bangchak.co.th/th/oilprice/widget' frameBorder='0' />}`
          }}
        ></div>
      )}

      {/* {
        dataOil !== null && <>
          <h2>ราคาน้ำมัน</h2>
          <div className='widget-oil-stat-box'>
            <div className='widget-oil-stat-list --head'>
              <p>ชนิด</p>
              <p>บาท/ลิตร</p>
            </div>
            <div className='widget-oil-stat-list'>
              <p>เบนซิน</p>
              <p><strong>{dataOil.Benzin}</strong></p>
            </div>
            <div className='widget-oil-stat-list'>
              <p>ดีเซล B10</p>
              <p><strong>{dataOil.DieselB10}</strong></p>
            </div>
            <div className='widget-oil-stat-list'>
              <p>แก๊สโซฮอล์ 91</p>
              <p><strong>{dataOil.Gasohol91}</strong></p>
            </div>
            <div className='widget-oil-stat-list'>
              <p>แก๊สโซฮอล์ 95</p>
              <p><strong>{dataOil.Gasohol95}</strong></p>
            </div>
            <div className='widget-oil-stat-list'>
              <p>แก๊สโซฮอล์ E20</p>
              <p><strong>{dataOil.GasoholE20}</strong></p>
            </div>
          </div>
          <p className='date-update'>อัพเดท {dataUpdate}</p>
        </>
      } */}
    </div>
  );
};

export default WidgetOilStat;
